import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import {
  getMessagingSettings,
  updateMessagingSettings,
} from "../../../services/instanceService";
import { MessagingConfig } from "../../../types/instanceTypes";

export const useMessagingSettings = () => {
  const { t } = useTranslation();
  const [messagingConfig, setMessagingConfig] = useState<MessagingConfig | null>(
null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchMessagingSettings = async () => {
    try {
      setLoading(true);
      const settings = await getMessagingSettings();
      setMessagingConfig(settings);
      setError(null);
    } catch (err) {
      setError(t("messagingSettings.failedToFetch"));
      console.error(t("messagingSettings.failedToFetch"));
    } finally {
      setLoading(false);
    }
  };

  const saveMessagingSettings = async (data: {
    messagingConfig: MessagingConfig;
  }) => {
    try {
      setLoading(true);
      const updatedSettings = await updateMessagingSettings(data);
      setMessagingConfig(updatedSettings);
      message.success(t("messagingSettings.updatedSuccessfully"));
      return true;
    } catch (err) {
      return false;
    } finally {
      setLoading(false);
    }
  };


  return {
    messagingConfig,
    setMessagingConfig,
    loading,
    error,
    saveMessagingSettings,
    fetchMessagingSettings,
  };
};